import type { AvailableColumn } from '../types'
import { isValidColumn } from './utils'

export const visibleWithPersistence = <Sort extends string = string>(
  visibleColumns: Array<AvailableColumn<Sort> | undefined>,
  columnWidths: Record<string, number> = {},
): Array<AvailableColumn<Sort>> => {
  const validColumns = visibleColumns.filter(isValidColumn)

  if (Object.keys(columnWidths).length === 0) {
    return validColumns
  }

  return validColumns.map((column) => {
    const width = columnWidths[column.id]

    if (width) {
      return { ...column, width }
    }

    return column
  })
}
